import countries from "__generated__/countries.json";
import { CountryCode, CountryPreviewFragment } from "__generated__/graphql";

export const getCountryOptions = (): CountryPreviewFragment[] => {
  return countries.map((country) => ({
    code: country.code as CountryCode,
    name: country.name,
    emojiFlag: country.emoji_flag,
  }));
};
